<md-tag [type]="tagType()">{{ invoiceStatus() }}</md-tag>
